
import apiRequest from "./apiRequest";

export const sh3RegisterApi = {

    fetchSh3Register: (accountId, token) => {
    return apiRequest(`/api/register/sh3?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitSh3Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/sh3?accountId=${accountId}`, 'POST', token, formData);
  },

 

  
};